// import store from "../../store";
import {
  createMetaField,
  updateMetaField,
  deleteMetaField,
  fetchMetaFields,
  fetchGlobalMetaFields,
  updateTemplateMetaFieldInDoc,
} from "./services";

export const fetchMetaFieldAction = (docMode, objectId) => dispatch =>
  new Promise((resolve, reject) => {
    fetchMetaFields(docMode, objectId)
      .then(res => {
        dispatch({
          type: "FETCH_META_FIELDS",
          payload: res ? res.meta_groups : [],
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const fetchGlobalMetaFieldAction =
  (docMode, metaFieldInfo) => dispatch =>
    new Promise((resolve, reject) => {
      fetchGlobalMetaFields(docMode, metaFieldInfo)
        .then(res => {
          dispatch({
            type: "UPDATE_GLOBAL_META_FIELDS",
            payload: {
              docMode,
              metaFieldInfo,
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const createMetaFieldAction =
  (docMode, objectId, metaFieldInfo) => dispatch =>
    new Promise((resolve, reject) => {
      createMetaField(docMode, objectId, metaFieldInfo)
        .then(res => {
          let metaGroupData = {};
          if (res) {
            metaGroupData = res.meta_group;
          }
          dispatch({
            type: "ADD_META_FIELD",
            payload: {
              docMode,
              metaFieldInfo,
              metaGroupData,
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const updateMetaFieldAction =
  (docMode, objectId, updatedObject) => dispatch =>
    new Promise((resolve, reject) => {
      updateMetaField(docMode, objectId, updatedObject)
        .then(res => {
          dispatch({
            type: "UPDATE_META_FIELD",
            payload: {
              docMode,
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const deleteMetaFieldAction =
  (docMode, objectId, metaFieldItemName) => dispatch =>
    new Promise((resolve, reject) => {
      deleteMetaField(docMode, objectId, metaFieldItemName)
        .then(res => {
          dispatch({
            type: "DELETE_META_FIELD",
            payload: {
              docMode,
              metaFieldItemName,
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const updateTemplateMetaFieldInDocAction =
  (docMode, objectId, metaGroupId, updatedMetaFieldName, updatedObject) =>
  dispatch =>
    new Promise((resolve, reject) => {
      updateTemplateMetaFieldInDoc(
        docMode,
        objectId,
        metaGroupId,
        updatedMetaFieldName,
        updatedObject,
      )
        .then(res => {
          dispatch({
            type: "UPDATE_TEMPLATE_META_FIELD_IN_DOC",
            payload: {
              updatedMetaFieldName,
              objectId,
              metaGroupId,
              updatedObject,
              res,
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
